module.exports = __webpack_public_path__ + "3899588c87c6005f96eff5fdafb57b21.MP3";